import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { BndesUx4 } from '@bndes/bndes-ux4';

import {
 
  ConfirmacaoTemplateDirective, ConfirmacaoModalComponent, SituacaoConfirmacaoService, ConfirmacaoModalService, BOTOES
 
} from './components';


import { RouterModule } from '@angular/router';

import { LoadingOverlayComponent } from './components/loading-overlay/component/loading-overlay.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BndesUx4,
    NgbModule
   ],
  providers: [
    SituacaoConfirmacaoService,
    ConfirmacaoModalService
  ],
  declarations: [
    ConfirmacaoTemplateDirective,
    ConfirmacaoModalComponent,
    LoadingOverlayComponent,
    ...BOTOES
  ],
  exports: [
    ConfirmacaoTemplateDirective,
    ConfirmacaoModalComponent,
    ...BOTOES
  ]
})
export class NgSharedModule {
  constructor( @Optional() @SkipSelf() parentModule: NgSharedModule) {
  }
}
